import { EMPTY_VALUE } from '@/constants/app.constants';
import { cn } from '@/lib/utils';
import { ExpandableComment } from './ExpandableComment';

interface BoxedTextProps {
  children: string | null;
  isMuted?: boolean | undefined;
  isExpandable?: boolean | undefined;
}

export function BoxedText({ children, isMuted = false, isExpandable = false }: BoxedTextProps) {
  const content =
    children && isExpandable ? (
      <ExpandableComment comment={children} shouldKeepLineBreaks />
    ) : (
      children || EMPTY_VALUE
    );

  return (
    <p
      className={cn(
        'rounded-lg border bg-background p-3 text-sm whitespace-pre-line',
        isMuted && 'font-normal text-muted-foreground',
      )}
    >
      {content}
    </p>
  );
}
